// extracted by mini-css-extract-plugin
export default {"wrap":"InputTodo_wrap__cC-AM","input":"InputTodo_input__5IR6h","button":"InputTodo_button__pICEp"};